import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { ApplicationIdleService } from "../services/application-idle.service";

@Injectable({
  providedIn: "root"
})
export class IdleSetupResolver implements Resolve<boolean> {
  constructor(
    private applicationIdle: ApplicationIdleService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this.applicationIdle.initialize();

    return true;
  }

}
